import { Injectable } from '@angular/core';
import { Http, Response, Headers, ConnectionBackend, RequestOptionsArgs, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/finally';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';



@Injectable()
export class HttpService extends Http {

  constructor(backend: ConnectionBackend, defaultOptions: RequestOptions, private router: Router, private authService: AuthService) {
    super(backend, defaultOptions);
  }

  get(url: string, options?: RequestOptionsArgs): Observable<any> {
    return super.get(url, options).retry(3)
      .catch(this.onCatch)
      .do((res: Response) => {
        this.onSuccess(res);
      }, (error: any) => {
        this.onError(error);
      }).finally(() => {
        this.onEnd();
      });
  }

  post(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
    return super.post(url, body, options)
      .catch(this.onCatch)
      .do((res: Response) => {
        this.onSuccess(res);
      }, (error: any) => {
        this.onError(error);
      }).finally(() => {
        this.onEnd();
      });
  }

  private onCatch(error: any, caught: Observable<any>): Observable<any> {
    return Observable.throw(error);
  }

  private onSuccess(res: Response): void {
  }

  private onError(res: Response): void {
    if (res.status === 401 || res.status === 403) {
      this.authService.logout();
      this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url} });
    }
  }

  private onEnd(): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/http.service.ts